import { useTitleChange } from '@msaf/core-react'
import HistorySearch from '../../../../components/well-forms/history/search'

export default function ViewWellHistory() {
  useTitleChange('View Well | History')
  return <HistorySearch />
}
